import React, { ComponentPropsWithRef } from 'react'
import { Shevron } from '~shared/icons/shevron'
import { cn } from '~shared/utils/cn'

export interface ArrowButtonProps extends ComponentPropsWithRef<'button'> {
  size?: 'lg' | 'sm'
  direction?: 'left' | 'right'
}

export const ArrowButton = React.forwardRef<
  HTMLButtonElement,
  Omit<ArrowButtonProps, 'ref'>
>(
  (
    { className, size = 'sm', disabled, direction = 'right', ...props },
    ref
  ) => {
    const params = {
      sm: 'h-[24px] w-[24px]',
      lg: 'h-[35px] w-[35px]',
      icon: '',
      default: ''
    }

    return (
      <button
        ref={ref}
        className={cn(
          'rounded-full transition-colors duration-300 border-none flex justify-center items-center cursor-pointer',
          disabled ? 'bg-[#C4C4C4]' : 'bg-black text-white hover:bg-accent',
          params[size ?? 'sm'],
          className
        )}
        disabled={disabled}
        {...props}>
        <Shevron
          size={size}
          className={cn(direction === 'left' && 'rotate-180')}
        />
      </button>
    )
  }
)
ArrowButton.displayName = 'ArrowButton'
